<div class="p-6">
  <h2 mat-dialog-title class="text-xl font-semibold mb-2">Award Project to Bidders</h2>
  <p class="text-sm text-gray-600 mb-4">
    Select one or more approved bidders to award the project. Each selected bidder will receive the project on their dashboard.
  </p>

  <div class="mb-4 flex gap-2">
    <button mat-stroked-button (click)="selectAll()">Select All</button>
    <button mat-stroked-button (click)="clearAll()">Clear All</button>
  </div>

  <div class="space-y-2 max-h-64 overflow-y-auto">
    <div *ngFor="let bid of data.shortlistedBids" 
         class="flex items-center gap-3 p-3 rounded-lg border cursor-pointer hover:bg-gray-50"
         [ngClass]="{'bg-purple-100': isSelected(bid.id)}"
         (click)="toggle(bid.id)">
      <mat-checkbox [checked]="isSelected(bid.id)" (change)="toggle(bid.id)" (click)="$event.stopPropagation()"></mat-checkbox>
      <div class="flex-1">
        <span class="font-medium">{{ bid.org_name }}</span>
        <span class="text-gray-600 ml-2">{{ formatCurrency(bid.bid_amount) }}</span>
      </div>
    </div>
  </div>

  <div mat-dialog-actions class="flex justify-end gap-2 pt-4">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="onAward()" [disabled]="submitting || selectedIds.size === 0">
      <mat-spinner *ngIf="submitting" diameter="20" class="inline-block mr-2"></mat-spinner>
      Award to {{ selectedIds.size }} Bidder(s)
    </button>
  </div>
</div>
